const partnerslist = [
  { designation: 'Human Resources', color: '#ECF9FF', description: '“WebHR is great. WebHR is easy to use, has good customer support and they are very responsive to our needs. They even have been very flexible with making custom program changes.’’', logo: 'https://images.unsplash.com/photo-1642802767826-55fb299a842e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDN8dG93SlpGc2twR2d8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60' },
  { designation: 'Human Resources', color: '#FFFAEB', description: '“WebHR is great. WebHR is easy to use, has good customer support and they are very responsive to our needs. They even have been very flexible with making custom program changes.’’', logo: 'https://images.unsplash.com/photo-1642622928474-c0ac98fccd29?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDd8dG93SlpGc2twR2d8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60' },
  { designation: 'Human Resources', color: '#FFF4F3', description: '“WebHR is great. WebHR is easy to use, has good customer support and they are very responsive to our needs. They even have been very flexible with making custom program changes.’’', logo: 'https://images.unsplash.com/photo-1642798874478-943c9729ffb1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDEzfHRvd0paRnNrcEdnfHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60' },
  { designation: 'Human Resources', color: '#F4F6FF', description: '“WebHR is great. WebHR is easy to use, has good customer support and they are very responsive to our needs. They even have been very flexible with making custom program changes.’’', logo: 'https://images.unsplash.com/photo-1642697778853-3ddddc65eb4f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDI1fHRvd0paRnNrcEdnfHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60' },
]

const partnership = [{ title: 'Earn Recurring Revenue Share' }, { title: 'Personal Portal with exclusive features' }, { title: 'Personal key account managers' }, { title: 'Onboard your clients without delay' }]
const affiliated = [{ title: 'Earn Commissions.' }, { title: 'Save Time and Money.' }, { title: 'Anyone can join.' }, { title: 'No Limits.' }]

const becomePartner = [
  {
    icon:"https://cdn.webhr.co/Website/images/partnership_program/why_become_Web_Partner_icons/recurring_revenue_share.svg",
    desc:"Recurring Revenue Share"
  },
  {
    icon:"https://cdn.webhr.co/Website/images/partnership_program/why_become_Web_Partner_icons/dedicated_support_managers.svg",
    desc:"Dedicated Support Managers"
  },
  {
    icon:"https://cdn.webhr.co/Website/images/partnership_program/why_become_Web_Partner_icons/address_clients_hr_issues.svg",
    desc:"Address Clients' HR issues"
  },
  {
    icon:"https://cdn.webhr.co/Website/images/partnership_program/why_become_Web_Partner_icons/exclusive_portal.svg",
    desc:"Exclusive Portal"
  },
  {
    icon:"https://cdn.webhr.co/Website/images/partnership_program/why_become_Web_Partner_icons/SwifClientOnboarding.svg",
    desc:"Swift Client Onboarding"
  },
  {
    icon:"https://cdn.webhr.co/Website/images/partnership_program/why_become_Web_Partner_icons/no_upfront_cost.svg",
    desc:"No Upfront Cost"
  },
]
const partnersData = [
  {
    image:"https://cdn.webhr.co/Website/images/partnership_program/ideal_partners/resellers.svg",
    title:"Resellers ",
    subtitle:"Extend your product suite by including WebHR in your offerings.",
    bgColor:"rgba(188, 228, 255, 0.3)"
  },
  {
    image:"https://cdn.webhr.co/Website/images/partnership_program/ideal_partners/hr_consultants_agencies.svg",
    title:"HR Consultants & Agencies",
    subtitle:"Enhance your consultation with the best HR software solution.",
    bgColor:"rgba(255, 242, 242, 0.9)"
  },
  {
    image:"https://cdn.webhr.co/Website/images/partnership_program/ideal_partners/startup_incubators_accelerators.svg",
    title:"Startup Incubators & Accelerators",
    subtitle:"Offer startups the HR foundation they need to grow.",
    bgColor:"rgba(251, 242, 255, 0.9)"
  },
  {
    image:"https://cdn.webhr.co/Website/images/partnership_program/ideal_partners/business_process_outsourcing.svg",
    title:"Business Process Outsourcing",
    subtitle:"Complement your services with HR tool that streamlines operations.",
    bgColor:"rgba(255, 247, 239, 0.9)"
  },
  {
    image:"https://cdn.webhr.co/Website/images/partnership_program/ideal_partners/industry_associations.svg",
    title:"Industry Associations",
    subtitle:"Equip your members with modern HR tools.",
    bgColor:"rgba(230, 240, 249, 0.9)"
  },
  {
    image:"https://cdn.webhr.co/Website/images/partnership_program/ideal_partners/industry_specific_partners.svg",
    title:"Industry-Specific Partners",
    subtitle:"Customize WebHR to fit your niche and meet unique HR needs.",
    bgColor:"rgba(238, 254, 255, 0.9)"
  },
]
const FaqsList = [
  {
    header:"What is the WebHR Partnership Program?",
    desc:"The WebHR Partnership Program is a collaborative initiative where businesses can integrate and offer WebHR's leading HR solutions to their clients, ensuring mutual growth through shared revenue models.",
  },
  {
    header:"Is there any cost involved in becoming a partner?",
    desc:"No, there's no upfront cost to become a WebHR partner. Our goal is mutual growth; as your clients benefit, so do you through shared revenue.",
  },
  {
    header:"Do I get training or support?",
    desc:"Absolutely! All our partners receive comprehensive training and have access to 24/7 support via live chat, email, and phone call to ensure seamless integration and promotion.",
  },
  {
    header:"How does the revenue-sharing model work?",
    desc:"For every client that integrates WebHR through your recommendation, you receive a percentage of the realized revenue, ensuring a win-win collaboration.",
  },
  {
    header:"Do I need technical expertise to become a partner?",
    desc:"While some understanding of HR software can be beneficial, it's not mandatory. Our team provides all the necessary training and support to ensure you're equipped to promote WebHR effectively.",
  },
  {
    header:"How do I onboard my clients?",
    desc:"",
  },{
    header:"How often will I get paid?",
    desc:"",
  },
]

const PartnerPageContent = {
  header:{
    banner:"https://cdn.webhr.co/Website/images/partnership_program/header_background.svg",
    heading:"Earn Up-to 20% Recurring Revenue for Every Referral",
    subHeading:"You want to grow your business faster. We're in the growth business. Explore our partner programs, find the one that's right for you, and let's start growing better together.",
    headerImage:"https://cdn.webhr.co/Website/images/partner_with_us/partnership_header_image.webp"
  },
  becomePartner:{
    heading:"Become a Partner with WebHR",
    columns:[
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/affiliate_program.svg",
        heading:"Affiliate Program",
        content:"WebHR’s affiliate program is simple and easy. All you need to do is recommend a potential client to Join the #1 HR Software and automate their HR Processes. WebHR will share the generated revenue in terms of commission.",
        redirectPage:"affiliate-program"
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partnership_program/header_img.svg",
        heading:"Partnership Program",
        content:"For WebHR customers are the #1 priority and for you as well. Let’s join together and provide a complete HR Solution to your clientele and help them grow in more effective way.",
        redirectPage:"partnership-program"
      }
    ]
  },
  whyPartner:{
    heading:"Why Partner with WebHR?",
    columns:[
      {
        banner:"https://cdn.webhr.co/Website/images/Partnership_Program/Statistics/Countries.svg",
        content:"Global outreach with 25000 companies in 200+ countries",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partnership_program/statistics/payroll_process.svg",
        content:"Payroll Localizations with 100+ countries",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/why_partner/3.svg",
        content:"24/7 Support via Live Chat, Email, and Phone Call",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/why_partner/4.svg",
        content:"Recognized by Gartner's GetApp as #1st Cloud Based HR Software Globally",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/why_partner/5.svg",
        content:"Featured bv PC Magazine as No.1st in the HR Software Industry",
      },
      
    ]
  },
  getStarted:{
    heading:"Here’s how much you could earn",
    subHeading:"Earn a 20% recurring commission for every single referral. And the more people from a team that join, the more commissions you earn!",
  },
  statistic:{
    columns:[
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/statictics/1.svg",
        heading:"25+",
        content:"Dynamic HR Modules",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/statictics/2.svg",
        heading:"+200",
        content:"Countries Globally",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/statictics/3.svg",
        heading:"+2M",
        content:"Employees Served",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/statictics/4.svg",
        heading:"1B+",
        content:"Generated Payroll",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/statictics/5.svg",
        heading:"+25k",
        content:"Companies Onboard",
      },
      {
        banner:"https://cdn.webhr.co/Website/images/partner_with_us/statictics/6.svg",
        heading:"40+",
        content:"Industries Globally",
      },
    ]
  }
}

export const getAllPartners = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(partnerslist), 50)
  })
}

export const getAllPartership = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(partnership), 50)
  })
}

export const getAllAffiliated = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(affiliated), 50)
  })
}

export const getAllBecomePartner = ()=>{
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(becomePartner), 50)
  })
}
export const getAllPartnerData = ()=>{
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(partnersData), 50)
  })
}
export const getFAQList = ()=>{
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(FaqsList), 50)
  })
}

export const getPartnerPageContent = ()=>{
  return new Promise((resolve, reject) => {
    resolve(PartnerPageContent)
  })
}
